import React from 'react';
import { WhatsappIcon } from '../Svg';
import './NewWhatsappBtn.css';
import WhiteArrowIcon from '../Svg/WhiteArrowIcon';
import { tagOnWhatsappButtonClick } from 'src/Tagging/SalesTagging';

function NewWhatsappBtn() {

  const whatsappUs = (e) => {

    e.preventDefault();
    tagOnWhatsappButtonClick();
    window.open(
      'https://api.whatsapp.com/send/?phone=27826223509',
      '_blank'
    );
  };

  return (
    <div className="newwhatsappbtn-wrapper">
      <button className="newwhatsappbtn" onClick={whatsappUs}>
        <WhatsappIcon
          strokeColor="#282828"
          fill="black"
          height="19"
          width="19" />
        <span className="newwhatsappbtn-wrapper-text">
          Message us on <strong>WhatsApp </strong><strong>on 082 622 3509</strong>
        </span>
        <WhiteArrowIcon/>
      </button>
    </div>
  );
}

export default NewWhatsappBtn;
